import React from 'react';
import { Stack } from '../stack';
import { PlayIcon } from '../../icons/play';
import { PauseIcon } from '../../icons/pause';
import { PlayButton } from '../playButton';
import { AudioPlayerDuration } from './components/duration';
import { AudioPlayerRoot } from './components/root';
import { AudioPlayerTrack } from './components/track';
import { ViewProps } from './model';

export const View: React.FC<ViewProps> = ({ onPlay, progress, audioDuration, size, sx, isPaused }) => {
  const ownerState = {
    size,
  };
  const ActionIcon = isPaused ? PlayIcon : PauseIcon;
  const duration = !audioDuration ? '--:--' : audioDuration;
  const disabled = !audioDuration;

  return (
    <AudioPlayerRoot ownerState={ownerState} sx={sx}>
      <PlayButton disabled={disabled} onClick={!disabled ? onPlay : undefined}>
        <ActionIcon sx={{ fontSize: '1.25rem' }} />
      </PlayButton>
      <Stack alignItems="center" className="audio-player-track-container" direction="row">
        <AudioPlayerTrack ownerState={ownerState} progress={progress} />
        <AudioPlayerDuration ownerState={ownerState}>{duration}</AudioPlayerDuration>
      </Stack>
    </AudioPlayerRoot>
  );
};
